import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import portfolioData from '../data/portfolioData';
import PortfolioModal from '../components/PortfolioModal';

const Portfolio = () => {
  const { t } = useTranslation();
  const [modalShow, setModalShow] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);
  const [filter, setFilter] = useState('all');

  const handleProjectClick = (project) => {
    setSelectedProject(project);
    setModalShow(true);
  };

  const handleCloseModal = () => {
    setModalShow(false);
  };

  const filteredProjects = filter === 'all' 
    ? portfolioData 
    : portfolioData.filter(project => project.category === filter);

  const categories = ['all', ...new Set(portfolioData.map(project => project.category))];

  return (
    <>
      {/* 頁面標題 */}
      <section className="py-5 bg-light">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <h1 className="display-4">{t('portfolio')}</h1>
              <p className="lead">探索我們的精選作品集</p>
            </div>
          </div>
        </div>
      </section>

      {/* 作品集 */}
      <section className="py-5">
        <div className="container">
          {/* 過濾器 */}
          <div className="mb-5 text-center">
            <div className="btn-group">
              {categories.map((category, index) => (
                <button 
                  key={index} 
                  className={`btn ${filter === category ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => setFilter(category)}
                >
                  {category === 'all' ? '全部' : category}
                </button>
              ))}
            </div>
          </div>

          {/* 作品項目 */}
          <div className="row">
            {filteredProjects.map(project => (
              <div className="col-md-4 mb-4" key={project.id}>
                <div className="portfolio-item card h-100">
                  <img src={project.image} className="card-img-top" alt={project.title} />
                  <div className="card-body">
                    <span className="card-category">{project.category}</span>
                    <h5 className="card-title">{project.title}</h5>
                    <p className="card-text">{project.description.substring(0, 100)}...</p>
                    {/* <button 
                      className="btn btn-outline-primary" 
                      onClick={() => handleProjectClick(project)}
                    >
                      {t('viewMore')}
                    </button> */}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 作品詳情模態框 */}
      <PortfolioModal 
        project={selectedProject} 
        show={modalShow} 
        onHide={handleCloseModal} 
      />
    </>
  );
};

export default Portfolio; 